module.exports = __webpack_public_path__ + "static/media/lock_icon.f5d30e7b.svg";